/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('popup.booking').directive('gccsPopupBookingShiftFormEmployeesBid', () => {
  return {
    restrict: 'A',
    controller: 'PopupBookingShiftFormEmployeesBidController',
    controllerAs: 'employeesBidCtrl',
    template: require('./template.pug'),
    scope: {
      clientId: '<',
      shift: '<',
      shiftEmployeeManager: '<',
      conflictedShiftEmployeeManager: '<',
      assignForShiftEmployee: '<',
      backCb: '&',
      timeLineLoader: '<',
      isShiftIssueInviteEmployee: '<',
      onClose: '&',
      editable: '<'
    }
  };
});
